if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"_vk_cloud_account_host","remotes":[{"alias":"@vk-cloud-account/host","name":"_vk_cloud_account_host","entry":"[@vk-cloud-account/host]/bundle.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1|401|435)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}